import TallyWrapper from "../../../../src/components/forms/tallyWrapper";
import * as React from 'react';
export default {
  TallyWrapper,
  React
};